import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Card } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Search, FileText, Clock, ArrowRight, Loader2 } from "lucide-react";

const fmtDate = (s) => s ? new Date(s).toLocaleDateString("pt-BR", { day: "numeric", month: "long", year: "numeric" }) : "";

export default function Blog() {
  const [data, setData] = useState({ items: [], tags: [], total: 0 });
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");
  const [tag, setTag] = useState("");

  const load = () => {
    setLoading(true);
    const p = new URLSearchParams({ published: true, page: 1, page_size: 30 });
    if (q) p.set("q", q);
    if (tag) p.set("tag", tag);
    api.get(`/blog?${p}`).then((r) => setData(r.data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [tag]);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
      <header className="mb-8">
        <span className="text-xs uppercase tracking-[0.25em] text-amber-700 font-bold flex items-center gap-1.5"><FileText size={14}/> Blog MorarBem</span>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-stone-900 mt-2">Histórias, dicas e novidades</h1>
        <p className="text-stone-600 mt-2 max-w-2xl">Tudo sobre comércio local, cashback inteligente e descobertas pra viver bem na sua cidade.</p>
      </header>

      <Card className="p-3 rounded-2xl border-stone-200 mb-6 flex items-center gap-2 flex-wrap">
        <div className="relative flex-1 min-w-[240px]">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-400"/>
          <Input value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} placeholder="Buscar..." className="rounded-xl pl-8" data-testid="blog-search"/>
        </div>
        <div className="flex flex-wrap gap-1.5">
          <button onClick={() => setTag("")} className={`px-3 py-1 rounded-full text-xs font-bold ${!tag ? "bg-blue-900 text-white" : "bg-stone-100 text-stone-700 hover:bg-stone-200"}`} data-testid="blog-tag-all">Todas</button>
          {data.tags.map((t) => (
            <button key={t} onClick={() => setTag(t)} className={`px-3 py-1 rounded-full text-xs font-bold uppercase ${tag === t ? "bg-blue-900 text-white" : "bg-amber-100 text-amber-900 hover:bg-amber-200"}`} data-testid={`blog-tag-${t}`}>{t}</button>
          ))}
        </div>
      </Card>

      {loading ? (
        <div className="py-20 text-center text-stone-400"><Loader2 className="mx-auto animate-spin" size={36}/></div>
      ) : data.items.length === 0 ? (
        <Card className="p-12 rounded-2xl border-stone-200 text-center" data-testid="blog-empty">
          <FileText className="mx-auto text-stone-300" size={48}/>
          <p className="font-display text-xl mt-3">Nada publicado ainda</p>
        </Card>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {data.items.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} className="group rounded-2xl bg-white border border-stone-200 hover:-translate-y-1 hover:shadow-xl transition-all overflow-hidden" data-testid={`blog-card-${p.slug}`}>
              <div className="aspect-[16/9] bg-stone-100 overflow-hidden">
                {p.cover_url ? <img src={p.cover_url} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"/> :
                  <div className="w-full h-full flex items-center justify-center text-stone-300"><FileText size={48}/></div>}
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  {p.tags?.slice(0, 2).map((t) => <span key={t} className="text-[10px] px-1.5 py-0.5 rounded bg-amber-100 text-amber-900 font-bold uppercase">{t}</span>)}
                  <span className="text-[10px] text-stone-400 flex items-center gap-0.5"><Clock size={10}/> {fmtDate(p.created_at)}</span>
                </div>
                <h2 className="font-display text-lg font-bold text-stone-900 leading-tight group-hover:text-blue-900">{p.title}</h2>
                <p className="text-sm text-stone-600 mt-1 line-clamp-2">{p.excerpt}</p>
                <span className="inline-flex items-center gap-1 mt-3 text-sm font-bold text-blue-900 group-hover:gap-2 transition-all">Ler mais <ArrowRight size={14}/></span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
